module.exports = __webpack_public_path__ + "img/faqs_soc.e76a0c49.jpg";